<template>
  <div class="no-access">
    <h3 class="wallet-title">No Access</h3>
    <p>Authentication invalid.</p>
  </div>
</template>

<script>
  export default {
    name: 'NoAccess',
  }
</script>

<style lang="sass" scoped>
  .no-access
    padding: 1em
    text-align: center
</style>
